<template>
  <div class="threejsContainer">
    <div class="containerTitle">1-4.控制器-拖拽控制器</div>
    <div ref="container" class="containerBody"></div>
  </div>
</template>

<script>
import * as THREE from 'three';
import {generateScene} from '@/threejsEnv/scene.js';
import {genPerspectiveCamera} from '@/threejsEnv/camera.js';
import {genRenderer} from '@/threejsEnv/renderer.js';
import {DragControls} from 'three/examples/jsm/controls/DragControls.js';


export default {
  data(){
    return {
      scene: null,
      camera: null, 
      renderer: null, 
      cube: null,
      animationId: null,
      control: null,
      window: {
        width: 0,
        height: 0
      }
    }
  },
  mounted(){
    this.window.width = window.innerWidth;
    this.window.height = window.innerHeight;

    this.scene = generateScene();
    
    this.camera = genPerspectiveCamera(this.window)

    const geometry = new THREE.BoxGeometry();
    const material = new THREE.MeshBasicMaterial({ color: 0x0000ff});
    const material1 = new THREE.MeshBasicMaterial({ color: 0x0000ff});
    
    this.cube = new THREE.Mesh(geometry, material);
    this.cube1 = new THREE.Mesh(geometry, material1);
    this.cube1.position.x = 1.0
    const objects = [];
    objects.push(this.cube);
    objects.push(this.cube1);
    this.scene.add(this.cube);
    this.scene.add(this.cube1);

    this.renderer = genRenderer(this.window); 

    this.control  = new DragControls(objects,this.camera, this.renderer.domElement); 

    this.$refs.container.appendChild(this.renderer.domElement);

    this.render();
    //添加监听
    window.addEventListener('resize', this.onWindowResize);
  },
  methods:{
    render() {
      this.animationId = requestAnimationFrame(this.render);
      this.renderer.render(this.scene, this.camera);
			this.cube.rotation.x -= 0.01;
			this.cube.rotation.y -= 0.01;
			this.cube.rotation.z -= 0.01;
      this.control.update();
    },
    onWindowResize(){
        const container = this.$refs.container;
        const width = container.clientWidth;
        const height = container.clientHeight;

        // 1. 更新相机的宽高比 (aspect)
        this.camera.aspect = width / height;
        // 【关键】更新相机的投影矩阵，使更改生效
        this.camera.updateProjectionMatrix();

        // 2. 更新渲染器的尺寸
        this.renderer.setSize(width, height);
    }
  },
  beforeDestroy(){
    cancelAnimationFrame(this.animationId);
    this.scene.remove(this.cube); // 从场景中移除模型
    this.cube.geometry.dispose(); // 释放几何体内存
    this.cube.material.dispose(); // 释放材质内存
    this.renderer.dispose(); // 释放渲染器内存
    this.renderer.domElement.remove(); // 从 DOM 中移除 canvas 元素
  },
  destroyed(){
    this.scene = null;
    this.camera = null;
    this.renderer = null;
    this.cube = null;
  }
}
</script>

<style scoped>

</style>